import g from '#core/global';
import load from '#core/load';


const container_$ = '.scorecard-table';
const button_$ = '.scorecard-table__more-button';
const sort_$ = '.scorecard-table__sort';
const tbody_$ = '.scorecard-table__tbody';
const row_$ = '.scorecard-table__row';
const hidden_row_$ = '.scorecard-table__row--hidden';
const hidden_class = 'scorecard-table__row--hidden';
const expanded_class = 'scorecard-table--expanded';
const reveal_index_var = '--scorecard-table-reveal-index';
const sort_direction_attr = 'data-sort-direction';
const sort_by_attr = 'data-sort-by';
const rank_attr = 'data-rank';

let has_scorecard_table = false;


const module = {
	/**
	 * Init module
	 */
	init() {
		if (load.ran('scorecard-table')) return false;

		load.content(() => {
			has_scorecard_table = assign_elements();
		});
	},
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_scorecard_table) return true;

	document.addEventListener(g.click_e, e => {
		const $button = e.target.closest(button_$);
		if (!$button) return false;

		const $container = $button.closest(container_$);
		if (!$container) return false;

		e.preventDefault();
		$container.querySelectorAll(hidden_row_$).forEach(($row, i) => {
			$row.style.setProperty(reveal_index_var, i);
		});
		$container.classList.add(expanded_class);
	});

	document.addEventListener(g.click_e, e => {
		const $sort = e.target.closest(sort_$);
		if (!$sort) return false;

		const $container = $sort.closest(container_$);
		if (!$container) return false;

		e.preventDefault();
		toggle_sort($container, $sort);
	});

	return true;
}


/**
 * Toggle sort direction on a column and reorder rows
 * @param {HTMLElement} $container
 * @param {HTMLElement} $sort
 * @return {void}
 */
function toggle_sort($container, $sort) {
	const current = $sort.getAttribute(sort_direction_attr);
	const next = current === 'ascending' ? 'descending' : 'ascending';
	const sort_by = $sort.getAttribute(sort_by_attr);

	$sort.setAttribute(sort_direction_attr, next);
	const $th = $sort.closest('th');
	if ($th) $th.setAttribute('aria-sort', next);

	sort_rows($container, sort_by, next);
}


/**
 * Sort table rows by the given key and direction
 * @param {HTMLElement} $container
 * @param {string} sort_by
 * @param {string} direction
 * @return {void}
 */
function sort_rows($container, sort_by, direction) {
	const $tbody = $container.querySelector(tbody_$);
	if (!$tbody) return;

	const $rows = Array.from($tbody.querySelectorAll(row_$));
	const sign = direction === 'ascending' ? 1 : -1;

	$rows.sort(($a, $b) => {
		const a_val = get_sort_value($a, sort_by);
		const b_val = get_sort_value($b, sort_by);
		return (a_val - b_val) * sign;
	});

	const is_expanded = $container.classList.contains(expanded_class);
	const show_count = count_visible($rows);

	$rows.forEach(($row, i) => {
		$tbody.appendChild($row);
		const should_hide = !is_expanded && i >= show_count;
		$row.classList.toggle(hidden_class, should_hide);
	});
}


/**
 * Read the sort value for a row
 * @param {HTMLElement} $row
 * @param {string} sort_by
 * @return {number}
 */
function get_sort_value($row, sort_by) {
	if (sort_by === 'rank') {
		return parseFloat($row.getAttribute(rank_attr)) || 0;
	}
	return 0;
}


/**
 * Count rows that are currently visible (not hidden)
 * @param {Array<HTMLElement>} $rows
 * @return {number}
 */
function count_visible($rows) {
	const hidden = $rows.filter($r => $r.classList.contains(hidden_class)).length;
	return $rows.length - hidden;
}
